/**
 * Click super app (`click.insonuchun.uz`) host adapter — `defineCookieHost`
 * factory orqali. Click webview `click-web-session` cookie ni yozadi, undan
 * keyin mini app uni `/MiniApp/ClickLogin` ga jo'natadi.
 *
 * iOS WKWebView da bu cookie ~100-1500ms kechikishi mumkin; factory polling
 * orqali bu kechikishni o'zi handle qiladi.
 */

import { COOKIES } from "@/lib/env";
import { defineCookieHost } from "./cookieHost";

export const clickHost = defineCookieHost({
  id: "click",
  brandId: "click",
  hostnames: ["click.insonuchun.uz", "ihma-bot-test.netlify.app"],
  loginEndpoint: "/MiniApp/ClickLogin",
  sessionCookies: [COOKIES.CLICK_WEB_SESSION, COOKIES.WEB_SESSION],
  langCookie: COOKIES.CLICK_LANGUAGE,
  themeCookie: COOKIES.CLICK_THEME,
});
